export const CLIENT_MOBILE = 'mobile';
export const CLIENT_DESKTOP = 'desktop';
export const CLIENT_TYPES = [CLIENT_MOBILE, CLIENT_DESKTOP] as const;
export const DEFAULT_CLIENT = CLIENT_MOBILE;
export const WEBSHOP_BOOZT = 'boozt';
export const WEBSHOP_BOOZTLET = 'booztlet';
export const WEBSHOP_TYPES = [WEBSHOP_BOOZT, WEBSHOP_BOOZTLET] as const;
export const DEFAULT_WEBSHOP = WEBSHOP_BOOZT;
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_STORE = 'eu';
